/** Default bot_schedule when none is stored in bot_settings.scheduling */

export const WEEKDAY_KEYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const WEEKDAY_LABELS = {
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
};

/** Weekdays: 8:00 AM–4:00 PM quiet hours (24h: 08:00–16:00). */
export const DEFAULT_WEEKDAY_QUIET_INTERVAL = { start: "08:00", end: "16:00" };

export const DEFAULT_WEEKDAY_QUIET_DAY = {
  is_active: true,
  intervals: [{ ...DEFAULT_WEEKDAY_QUIET_INTERVAL }],
};

/** Weekend: no quiet hours — bot may respond all day. */
export const DEFAULT_WEEKEND_QUIET_DAY = {
  is_active: false,
  intervals: [],
};

const copyDaySchedule = (day) =>
  JSON.parse(JSON.stringify(day));

export const DEFAULT_BOT_SCHEDULE = {
  enabled: false,
  timezone: "Australia/Sydney",
  weekly_schedule: {
    monday: copyDaySchedule(DEFAULT_WEEKDAY_QUIET_DAY),
    tuesday: copyDaySchedule(DEFAULT_WEEKDAY_QUIET_DAY),
    wednesday: copyDaySchedule(DEFAULT_WEEKDAY_QUIET_DAY),
    thursday: copyDaySchedule(DEFAULT_WEEKDAY_QUIET_DAY),
    friday: copyDaySchedule(DEFAULT_WEEKDAY_QUIET_DAY),
    saturday: copyDaySchedule(DEFAULT_WEEKEND_QUIET_DAY),
    sunday: copyDaySchedule(DEFAULT_WEEKEND_QUIET_DAY),
  },
  overrides: [
    {
      date: "2026-12-25",
      is_active: false,
      intervals: [],
      reason: "Christmas Day",
    },
    {
      date: "2026-12-26",
      is_active: true,
      intervals: [{ start: "10:00", end: "14:00" }],
      reason: "Boxing Day Short Shift",
    },
  ],
};

/** Deep-merge stored bot_schedule with defaults (missing days/fields). */
export function normalizeBotSchedule(raw) {
  const base = JSON.parse(JSON.stringify(DEFAULT_BOT_SCHEDULE));
  if (!raw || typeof raw !== "object") {
    return base;
  }

  const weekly = { ...base.weekly_schedule };
  const rawWeekly = raw.weekly_schedule || {};
  for (const key of WEEKDAY_KEYS) {
    const day = rawWeekly[key];
    if (day && typeof day === "object") {
      weekly[key] = {
        is_active: !!day.is_active,
        intervals: Array.isArray(day.intervals)
          ? day.intervals.map((iv) => ({
              start: iv?.start || "",
              end: iv?.end || "",
            }))
          : [],
      };
    }
  }

  const overrides = Array.isArray(raw.overrides)
    ? raw.overrides.map((o) => ({
        date: o?.date || "",
        is_active: !!o.is_active,
        reason: o?.reason || "",
        intervals: Array.isArray(o.intervals)
          ? o.intervals.map((iv) => ({
              start: iv?.start || "",
              end: iv?.end || "",
            }))
          : [],
      }))
    : base.overrides;

  return {
    enabled: raw.enabled !== undefined ? !!raw.enabled : base.enabled,
    timezone: raw.timezone || base.timezone,
    weekly_schedule: weekly,
    overrides,
  };
}
